module.exports = __webpack_public_path__ + "static/DonaAlt-Bold-98049ce1e7b80097fd191f9e44d630c1.woff";